import { Injectable, inject } from '@angular/core';
import { ClientInfo } from '../interfaces/client-info';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationsApi {
  private httpService = inject(SiaHttpService);

  private readonly pushNotificationsController: string = 'notifications';

  subscribe(clientInfo: ClientInfo): Promise<any> {
    return this.httpService.post(
      `${this.pushNotificationsController}/push-subscribe`,
      clientInfo,
    );
  }
}
